// Sample blog post data
// You can expand this structure as needed
export const blogPost = {
  title: 'Getting Started with Web Development',
  date: '2024-01-20',
  author: 'Tanay Raj',
  content: `
    <h2>Introduction</h2>
    <p>Web development is an exciting field that combines creativity with technical skills. Whether you're looking to build your first website or start a career in tech, this guide will help you understand the fundamentals.</p>
    
    <h2>What is Web Development?</h2>
    <p>Web development involves creating websites and web applications that run on the internet or intranet. It's divided into two main areas:</p>
    <ul>
      <li><strong>Frontend Development:</strong> The part users see and interact with</li>
      <li><strong>Backend Development:</strong> The server-side logic and database management</li>
    </ul>
    
    <h2>Essential Technologies</h2>
    <h3>HTML (HyperText Markup Language)</h3>
    <p>HTML is the foundation of every web page. It structures content using elements like headings, paragraphs, links, and images.</p>
    
    <h3>CSS (Cascading Style Sheets)</h3>
    <p>CSS controls the visual appearance of HTML elements. It handles layout, colors, fonts, and responsive design.</p>
    
    <h3>JavaScript</h3>
    <p>JavaScript adds interactivity to web pages. It's a programming language that runs in the browser and can manipulate HTML and CSS.</p>
    
    <h2>Getting Started</h2>
    <ol>
      <li>Choose a code editor (VS Code is recommended)</li>
      <li>Learn HTML basics</li>
      <li>Master CSS fundamentals</li>
      <li>Dive into JavaScript</li>
      <li>Practice by building projects</li>
    </ol>
    
    <h2>Conclusion</h2>
    <p>Web development is a journey of continuous learning. Start with the basics, practice regularly, and don't be afraid to experiment. The web development community is welcoming and full of resources to help you grow.</p>
  `,
  tags: ['web development', 'html', 'css', 'javascript', 'beginner'],
  readTime: '5 min read',
  // Omit `related` to auto-link every other entry from portfolio.js (incl. external).
}

export default blogPost
